export default {
  backgroundImageBase: {
    width: '100%',
    height: '100%',
    backgroundPosition: 'center',
    backgroundSize: 'cover, auto',
    backgroundRepeat: 'repeat, no-repeat',
    objectFit: 'cover',
    objectPosition: '50% 50%'
  },
  flightBoxImage: {
    paddingTop: '98px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '@media (min-width: 801px),print': {
      paddingTop: '0',
      boxSizing: 'content-box !important'
    }
  },
  gold: {
    color: data => data.mainColor
  },
  size32: {
    fontSize: '32px'
  },
  size20: {
    fontSize: '20px'
  },
  size22: {
    fontSize: '22px'
  },
  size23: {
    fontSize: '23px'
  },
  size24: {
    fontSize: '24px'
  },
  size25: {
    fontSize: '25px'
  },
  size27: {
    fontSize: '27px'
  },
  size16: {
    fontSize: '16px'
  },
  size15: {
    fontSize: '15px'
  },
  size11: {
    fontSize: '11px'
  },
  size10: {
    fontSize: '10px'
  },
  accesibilityImage:{
    position: 'absolute',
    left:'-99999px',
    top:'-999999px',
    opacity:0,
    visibility:'hidden',
    zIndex:'-10',
    '&:lang(ar)':{
     display: 'none',
    }
  }
};
